import React from 'react'
import SearchIcon from '@mui/icons-material/Search'
import withStyles from '@mui/styles/withStyles'
import CustomEmpty from '../../smallComponents/CustomEmpty'
import EmptyComponentModel from '../../emptyComponentModel/EmptyComponentModel'
import i18next from 'i18next'

const styles = () => ({
  warpper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
  },
  searchIcon: {
    fontSize: 20,
  },
  query: {
    fontStyle: 'oblique',
    fontWeight: 400,
  },
})

const NoSearchSystemResults = ({ searchQuery, classes, isDarkModeActive }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <CustomEmpty
      isDarkModeActive={isDarkModeActive}
      emptyMssg={
        <EmptyComponentModel
          emptySentence={
            <section className={classes.warpper}>
              <SearchIcon
                className={classes.searchIcon}
                style={{
                  margin: rtl ? '3px 0px -3px 10px' : '3px 10px -3px 0',
                }}
              />
              <span>
                {searchQuery?.length < 4 ? (
                  rtl ? (
                    'يجب ان تكون كلمة البحث أكثر من 4 حروف'
                  ) : (
                    'Search keyword should not be less than 4 letters'
                  )
                ) : (
                  <>
                    {rtl ? 'لا توجد نتائج بحث ' : 'No Search Results'}
                    <>
                      {' '}
                      {rtl ? 'لـ' : 'for'}{' '}
                      <span className={classes.query}>{searchQuery}</span>
                    </>
                  </>
                )}
              </span>
            </section>
          }
        />
      }
      imageKey='noGSResults'
    />
  )
}

const WrappedNoSearchSystemResults = withStyles(styles)(NoSearchSystemResults)

export default WrappedNoSearchSystemResults
